import React, { Component } from 'react'
import InstanciaBasic from './InstanciaBasic.js'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import LocaleFormat from '../../../commons/utils/LocaleFormat.js';

class InstanciaDate extends InstanciaBasic {
	constructor(props) {
        super(props);
        this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
    }

    handleDatePickerFormChange(event) {
       this.props.handleChange(this.valueKey, event.format('YYYY-MM-DD'));
    }

    handleDatePickerFormRawChange(date) {
    }

	render() {
      return (
        <React.Fragment>
            <DatePicker id = "fecha"
                name = "fechaActual"
                className = "form-control date-picker-placeholder"
                selected = { this.props.atributo[this.valueKey] === null || this.props.atributo[this.valueKey]==='' || this.props.atributo[this.valueKey] === '0000-00-00' ? null : moment(this.props.atributo[this.valueKey]) }
                placeholderText = "DD/MM/AAAA"
                onChange = { (event) => this.handleDatePickerFormChange(event) }
                onChangeRaw = { (event) => this.handleDatePickerFormRawChange(event.target.value) }
                dateFormat={LocaleFormat.getDatePickerFormat()}
            />
        </React.Fragment>
      )
  }
}

export default InstanciaDate;
